import axios from "axios";
import { useEffect, useState } from "react";
import { OrbitProgress } from "react-loading-indicators";
import {Outlet, Navigate} from "react-router-dom"
import { API_BASE_URL, NUMBER_ADMIN } from "../../config/config";

// protection des routes dashboard
const ProtectedRoutesDashboard = () => {

     const [user, setUser] = useState(null);
    
      useEffect(() => {
        axios.get(`${API_BASE_URL}/auth/me`, { withCredentials: true })
          .then(res => {
            console.log("Réponse API :", res.data); // 🔍 debug
            setUser(res.data); // car l'API renvoie directement l'objet user
          })
          .catch(err => console.error(err));
      }, []);
    
      if (!user) {
        return <div className="text-center mt-20 py-8 text-gray-400"><OrbitProgress variant="track-disc" color="#125f69ff" size="small" text="" textColor="#484e51ff" /></div>
      }

    // verification si le user connecte et supra
    let isGrantedUsersSupra = false;
    if (user.phone == NUMBER_ADMIN) {
        isGrantedUsersSupra = true
    } 
    
    return isGrantedUsersSupra ? <Outlet/> : <Navigate to="/mksp/login"/>
}

export default ProtectedRoutesDashboard
